import React from "react";
import Hiring from "../../assets/hiring2.gif";

const Hero = () => {
  return (
    <div className="relative w-full overflow-hidden">
      {/* Content */}
      <div className=" relative z-10 flex h-full flex-col lg:flex-row items-center mt-20">
        {/* Text Content */}
        <div className="max-w-2xl text-center lg:text-left  mt-20 lg:mt-0">
          <h1 className="mb-4 text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            Join Our Team
          </h1>
          <p className="text-lg text-gray-400 mt-6">
            At Multify Solutions, we are at the forefront of transforming the
            digital landscape with innovative technology solutions. Our team is
            dedicated to excellence in software design, development,
            customization, and implementation. If you're passionate about
            technology and eager to make a significant impact, we invite you to
            explore the exciting career opportunities with us.
          </p>
          <button className="text-white px-6 py-3 bg-[#339d90] rounded-lg mt-8 hover:bg-[#2a7f74] transition-colors">
            Read More
          </button>
        </div>

        {/* Image Container */}
        <div className="flex items-center justify-center lg:justify-end w-full mt-12 lg:mt-0">
          <img
            style={{ animationDuration: "3s" }}
            className="h-auto w-[400px] sm:w-[600px] lg:w-[800px] animate-float rounded-lg"
            src={Hiring}
            alt="Server"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
